module.exports = __webpack_public_path__ + "static/safari-lawn-care-9324da2f3ef2a15984fead4861aac992.png";